/*  ========================================================================
    # Main JavaScript
    ========================================================================  */

// Polyfills
// =============================================================================

import 'whatwg-fetch';

// Scripts
// =============================================================================

import PageStates from './scripts/page-states';
import Menu from './scripts/menu';
import Slider from './scripts/slider';
import BlockLocation from './scripts/block-location';

const arrayScripts = [PageStates, Menu, Slider, BlockLocation];

const Scripts = {
  init() {
    if (arrayScripts.length > 0 && arrayScripts !== undefined) {
      arrayScripts.forEach(script => {
        script.init();
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  Scripts.init();
});

// Vendors
// =============================================================================

import './vendors/smooth-scroll';
